module.exports = __webpack_public_path__ + "img/Comfort.5cd240c6.svg";